module.exports = __webpack_public_path__ + "static/img/s152.e1556994.png";